/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminOrderMarketplace
 */
export interface AdminOrderMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderMarketplace
     */
    link: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminOrderMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderMarketplace
     */
    price: string;
}



export function AdminOrderMarketplaceFromJSON(json: any): AdminOrderMarketplace {
    return AdminOrderMarketplaceFromJSONTyped(json, false);
}

export function AdminOrderMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOrderMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': json['link'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
    };
}

export function AdminOrderMarketplaceToJSON(value?: AdminOrderMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
    };
}

